module.exports = __webpack_public_path__ + "static/media/ru.b15cce37.svg";